import React from 'react';
import { Typography, Box, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import moment from 'moment';
import logo from '../../../src/assets/Images/Clanbridge-logo.png2.png';

const CheckoutRequestReport = React.forwardRef(({ DataObj, contentRef }, ref) => {
    const formatDate = (date) => {
        if (!date || !moment(date).isValid()) return '';
        return moment(date).format('DD/MM/YYYY');
    };

    const getBookingStatus = (bookSt) => {
        switch (bookSt) {
            case "C": return "Confirmed";
            case "B": return "Booked";
            case "O": return "CheckedIn";
            case "L": return "CheckOut";
            case "X": return "Cancelled";
            default: return "Unknown";
        }
    };

    return (
        <Box ref={contentRef} sx={{ padding: 2, fontFamily: 'Arial, sans-serif' }}>
            <Box sx={{
                position: 'relative',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: 3,
                borderBottom: '2px solid #000',
                paddingBottom: 2,
                minHeight: '100px'
            }}>
                <Box sx={{ textAlign: 'center' }}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1976d2', mb: 0.5 }}>
                        CHECK-OUT REQUEST REPORT
                    </Typography>
                    <Typography variant="p" sx={{ color: '#666', mb: 0.5 }}>
                        Clanbridge Living
                    </Typography>
                    <Typography variant="body2">
                        Generated on: {moment().format('DD/MM/YYYY HH:mm')}
                    </Typography>
                </Box>

                <Box sx={{
                    position: 'absolute',
                    top: '10%',
                    right: 0,
                    transform: 'translateY(-50%)'
                }}>
                    <img
                        src={logo}
                        alt="Clanbridge Logo"
                        style={{
                            height: '80px',
                            width: 'auto',
                            maxWidth: '120px',
                            objectFit: 'contain'
                        }}
                    />
                </Box>
            </Box>
            <Grid container spacing={2} sx={{ marginBottom: 2 }}>
                <Grid item xs={12}>
                    <Typography variant="h6" sx={{ backgroundColor: '#f5f5f5', padding: 1, fontWeight: 'bold' }}>
                        Resident & Booking Details
                    </Typography>
                </Grid>

                <Grid item xs={6}>
                    <TableContainer component={Paper} variant="outlined">
                        <Table size="small">
                            <TableBody>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold', width: '40%' }}>Property Name</TableCell>
                                    <TableCell>{DataObj.PropName || 'N/A'}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Resident Name</TableCell>
                                    <TableCell>{DataObj.ResidentName || 'N/A'}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Mobile No</TableCell>
                                    <TableCell>{DataObj.MobileNo || 'N/A'}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Email</TableCell>
                                    <TableCell>{DataObj.Email || 'N/A'}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>

                <Grid item xs={6}>
                    <TableContainer component={Paper} variant="outlined">
                        <Table size="small">
                            <TableBody>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold', width: '40%' }}>Booking No</TableCell>
                                    <TableCell>{DataObj.BookNo || 'N/A'}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Booking Date</TableCell>
                                    <TableCell>{formatDate(DataObj.BookDt)}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Booking Status</TableCell>
                                    <TableCell>{getBookingStatus(DataObj.BookSt)}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Duration</TableCell>
                                    <TableCell>{DataObj.Duration || 'N/A'} months</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>

            <Grid container spacing={2} sx={{ marginBottom: 2 }}>
                <Grid item xs={12}>
                    <Typography variant="h6" sx={{ backgroundColor: '#f5f5f5', padding: 1, fontWeight: 'bold' }}>
                        Room Details
                    </Typography>
                </Grid>

                <Grid item xs={12}>
                    <TableContainer component={Paper} variant="outlined">
                        <Table size="small">
                            <TableBody>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold', width: '20%' }}>Wing</TableCell>
                                    <TableCell>{DataObj.WingName || 'N/A'}</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold', width: '20%' }}>Floor</TableCell>
                                    <TableCell>{DataObj.FloorName || 'N/A'}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Room Type</TableCell>
                                    <TableCell>{DataObj.RoomTypeName || 'N/A'}</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Bed No</TableCell>
                                    <TableCell>{DataObj.RoombedName || 'N/A'}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Bed Type</TableCell>
                                    <TableCell>{DataObj.RoomBedTypeName || 'N/A'}</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Standard Rent</TableCell>
                                    <TableCell>₹{DataObj.BedRent || '0'}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
            <Grid container spacing={2} sx={{ marginBottom: 2 }}>
                <Grid item xs={12}>
                    <Typography variant="h6" sx={{ backgroundColor: '#f5f5f5', padding: 1, fontWeight: 'bold' }}>
                        Check-out Request Information
                    </Typography>
                </Grid>

                <Grid item xs={12}>
                    <TableContainer component={Paper} variant="outlined">
                        <Table size="small">
                            <TableBody>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold', width: '25%' }}>Request Checkout Date</TableCell>
                                    <TableCell>{DataObj.ReqCheckoutDt || 'N/A'}</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold', width: '25%' }}>Expected Checkout Date</TableCell>
                                    <TableCell>{DataObj.expectedcheckout || 'N/A'}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Actual Check-in Date</TableCell>
                                    <TableCell>{formatDate(DataObj.CheckinDt)}</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Original Checkout Date</TableCell>
                                    <TableCell>{formatDate(DataObj.BookUpToDt)}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Bill Cycle</TableCell>
                                    <TableCell>
                                        {DataObj.BillCycle === 'S' ? 'Second' :
                                            DataObj.BillCycle === 'F' ? 'First' :
                                                DataObj.BillCycle || 'N/A'}
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Mark as Checkout</TableCell>
                                    <TableCell>{DataObj.IsCheckout ? 'Yes' : 'No'}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold', verticalAlign: 'top' }}>Reason for Checkout</TableCell>
                                    <TableCell colSpan={3} sx={{ whiteSpace: 'pre-wrap' }}>
                                        {DataObj.Resion || 'No reason provided'}
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="h6" sx={{ backgroundColor: '#f5f5f5', padding: 1, fontWeight: 'bold' }}>
                        Financial Summary
                    </Typography>
                </Grid>

                <Grid item xs={12}>
                    <TableContainer component={Paper} variant="outlined">
                        <Table size="small">
                            <TableBody>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold', width: '25%' }}>Total Rent</TableCell>
                                    <TableCell>₹{DataObj.TotalRent || '0'}</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold', width: '25%' }}>Discount Amount</TableCell>
                                    <TableCell>₹{DataObj.DiscAmt || '0'}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Net Amount</TableCell>
                                    <TableCell>₹{DataObj.NetAmt || '0'}</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Monthly Amount</TableCell>
                                    <TableCell>₹{DataObj.MonthlyAmt || '0'}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Topup Amount</TableCell>
                                    <TableCell>₹{DataObj.TopupAmt || '0'}</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Advance Receivable</TableCell>
                                    <TableCell>₹{DataObj.AdvcRcble || '0'}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>

            <Box sx={{ marginTop: 2, textAlign: 'center', borderTop: '1px solid #000', paddingTop: 2 }}>
                <Typography variant="body2" sx={{ color: '#666' }}>
                    This is a computer generated report. No signature required.
                </Typography>
                <Typography variant="body2" sx={{ color: '#666', marginTop: 1 }}>
                    Clanbridge Living - Providing Quality Accommodation Services
                </Typography>
            </Box>
        </Box>
    );
});

CheckoutRequestReport.displayName = 'CheckoutRequestReport';

export default CheckoutRequestReport;